import { Component, signal, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort, SortDirection } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { FatService, FatDto } from '../../../core/services/fat.service';

@Component({
    selector: 'app-fat-list',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatPaginatorModule,
        MatSortModule,
        MatIconModule
    ],
    templateUrl: './fat-list.component.html',
    styleUrls: ['./fat-list.component.css'],
})
export class FatListComponent implements OnInit {
    constructor(private router: Router) { }
    fatService = inject(FatService);

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    fats = signal<FatDto[]>([]);
    totalElements = signal(0);
    page = signal(0);
    size = signal(10);
    searchQuery = '';
    sortField = 'createdAt';
    sortDirection: SortDirection = 'desc';

    private searchSubject = new Subject<string>();

    ngOnInit() {
        this.loadFats();

        this.searchSubject.pipe(
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(query => {
            this.searchQuery = query;
            this.page.set(0);
            this.loadFats();
        });
    }

    loadFats() {
        const sortParam = `${this.sortField},${this.sortDirection}`;
        this.fatService.getAllFats(this.searchQuery, this.page(), this.size(), sortParam)
            .subscribe({
                next: response => {
                    this.fats.set(response.content);
                    this.totalElements.set(response.totalElements);
                }
            });
    }

    onSearchChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.searchSubject.next(value);
    }

    onSortChange(sortState: Sort) {
        this.sortField = sortState.active;
        this.sortDirection = sortState.direction || 'asc';
        this.page.set(0);
        this.loadFats();
    }

    onPageChange(event: PageEvent) {
        this.page.set(event.pageIndex);
        this.size.set(event.pageSize);
        this.loadFats();
    }

    onView(fat: FatDto) {
        this.router.navigate(['/projects', fat.projectId, 'fats', fat.id]);
    }
}
